import * as React from 'react'
import { formatTime } from '../service/util'


export default class Clock extends React.PureComponent<{
  time: number,
  onClick?: () => void
}> {

  onClick = () => {
    this.props.onClick && this.props.onClick()
  }

  render() {
    const { time } = this.props

    return (
      <div onClick={this.onClick} className="clock">{formatTime(time)}</div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/comp/clock.tsx